export default function StopIcon(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" {...props} xmlns="http://www.w3.org/2000/svg">
      <path fill={props?.fill || "#fff"} d="M16 2.66667V13.2958C16 14.7688 14.8063 15.9625 13.3333 15.9625H2.66667C1.19375 15.9625 0 14.7688 0 13.2958V2.66667C0 1.19375 1.19375 0 2.66667 0H13.3333C14.8042 0 16 1.19375 16 2.66667Z" />
    </svg>
  )
}
